import { render, staticRenderFns } from "./HealthrecordsStaistics.vue?vue&type=template&id=597162c2&scoped=true"
import script from "./HealthrecordsStaistics.vue?vue&type=script&lang=js"
export * from "./HealthrecordsStaistics.vue?vue&type=script&lang=js"
import style0 from "./HealthrecordsStaistics.vue?vue&type=style&index=0&id=597162c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597162c2",
  null
  
)

export default component.exports